'use client';
var classes = {"root":"m-87cf2631"};

export { classes as default };
//# sourceMappingURL=UnstyledButton.module.css.mjs.map
